import { useEffect } from "react";
import { Link } from "react-router-dom";
import QuoteForm from "../components/QuoteForm";
import ExperienceSection from "../components/ExperienceSection";

export default function Page() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.$) {
      const $ = window.$;

      // 1. Simple Counter Up
      if ($(".number1").length) {
        $.fn.$SimpleCounter = function (options) {
          var settings = $.extend({ start: 0, end: 100, easing: "swing", duration: 400, complete: "" }, options);
          var thisElement = $(this);
          $({ count: settings.start }).animate(
            { count: settings.end },
            {
              duration: settings.duration,
              easing: settings.easing,
              step: function () {
                var mathCount = Math.ceil(this.count);
                thisElement.text(mathCount);
              },
              complete: settings.complete,
            }
          );
        };
        $(".number1").$SimpleCounter({ end: 500, duration: 3000 });
        $(".number2").$SimpleCounter({ end: 350, duration: 3000 });
        $(".number3").$SimpleCounter({ end: 8, duration: 2000 });
        $(".number4").$SimpleCounter({ end: 15, duration: 2500 });
      }

      // 2. Search block
      $(".search-block").off("click").on("click", function () {
        $(".search-box").fadeToggle("slow").css({ top: "61px" });
        $(".search-block .fa").toggleClass("fa-times fa-search").addClass("fa-search");
      });

      // 3. GLightbox
      if ($(".btn_gallery").length && typeof GLightbox !== "undefined") {
        const galleryLightbox = GLightbox({ selector: ".btn_gallery" });
      }

      // 4. Hero Swiper
      if ($(".hero-slider").length && typeof Swiper !== "undefined") {
        const sliderItems = document.querySelectorAll(".slider-item");
        const container = document.querySelectorAll(".slide_img_container");
        const slice = 10;

        const swiper99 = new Swiper(".hero-slider", {
          direction: "horizontal",
          loop: true,
          autoplay: { delay: 5000, disableOnInteraction: false },
          speed: 2000,
          pagination: { el: ".swiper-pagination", type: "bullets", clickable: true },
          navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
          on: {
            slideChange: function () {
              sliderItems.forEach((item) => item.classList.remove("animate"));
              sliderItems.forEach((item) => setTimeout(() => $(item).addClass("animate"), 1000));
              splitImage("", slice, slice, container);
            },
          },
        });

        swiper99.on("slideChange", function () {
          updatePagination(this);
        });

        function updatePagination(swiper) {
          if (!swiper.slides || swiper.slides.length === 0) return;
          var currentSlide = swiper.slides[swiper.activeIndex];
          if (!currentSlide) return;
          var nextSlide = swiper.slides[(swiper.activeIndex + 1) % swiper.slides.length];
          var prevSlide = swiper.slides[(swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length];

          var containerEl = currentSlide.querySelector(".slide_img_container");
          var currentImageSrc = containerEl ? containerEl.getAttribute("data-src") : "";
          var nextContainerEl = nextSlide.querySelector(".slide_img_container");
          var nextImageSrc = nextContainerEl ? nextContainerEl.getAttribute("data-src") : "";
          var prevContainerEl = prevSlide.querySelector(".slide_img_container");
          var prevImageSrc = prevContainerEl ? prevContainerEl.getAttribute("data-src") : "";

          var paginationBullets = document.querySelectorAll(".swiper-pagination-bullet");
          if (paginationBullets.length > swiper.activeIndex) {
            paginationBullets[swiper.activeIndex].style.backgroundImage = "url(" + currentImageSrc + ")";
          }
          var prevIndex = (swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length;
          if (paginationBullets.length > prevIndex) {
            paginationBullets[prevIndex].style.backgroundImage = "url(" + prevImageSrc + ")";
          }
          var nextIndex = (swiper.activeIndex + 1) % swiper.slides.length;
          if (paginationBullets.length > nextIndex) {
            paginationBullets[nextIndex].style.backgroundImage = "url(" + nextImageSrc + ")";
          }
        }

        function splitImage(imageUrl, numCols, numRows, container) {
          container.forEach((item) => {
            item.innerHTML = "";
            item.classList.remove("bg-animate-duration", "bg-animate");
            for (let y = 0; y < numRows; y++) {
              for (let x = 0; x < numCols; x++) {
                const div = document.createElement("div");
                div.className = "animation-part";
                div.style.backgroundImage = `url('${imageUrl}')`;
                const posX = x * 100;
                const posY = y * 100;
                div.style.backgroundPosition = `-${posX}% -${posY}%`;
                item.appendChild(div);
              }
            }
            setTimeout(() => {
              item.classList.add("bg-animate-duration", "bg-animate");
            }, 2000);
          });
        }

        updatePagination(swiper99);
        splitImage("", slice, slice, container);
        $(".swiper-pagination-bullet").addClass("swiper-pagination-style");
      }

      // 5. Isotope Gallery
      if ($("#portfolio-filter7").length && typeof $.fn.isotope !== "undefined") {
        var $container = $("#portfolio-filter7").isotope({
          itemSelector: ".item",
          isFitWidth: true,
        });
        $(window).resize(function () {
          $container.isotope({ columnWidth: ".col-sm-3" });
        });
        $container.isotope({ filter: "*" });
        $("#filters").off("click", "button").on("click", "button", function () {
          var filterValue = $(this).attr("data-filter");
          $container.isotope({ filter: filterValue });
          $("#filters button").removeClass("active");
          $(this).addClass("active");
        });
      }

      // 6. AOS animations
      if (typeof AOS !== "undefined") {
        AOS.init({ easing: "ease-in-out-sine" });
      }

      // 7. Mobile menu toggle handlers
      const $menuArea = $(".mobile-menu-area");
      const $hamburger = $(".mobile-menu-toggle-new-line");
      const $menuClose = $(".mobile-menu-area .mobile-menu-close");
      const $menuOverlay = $(".mobile-menu-area .mobile-menu-overlay");

      $hamburger.off("click").on("click", function () {
        $menuArea.addClass("menu-open");
        $("body").css("overflow", "hidden");
        $(".line").addClass("change");
      });

      function closeMenu() {
        $menuArea.removeClass("menu-open");
        $("body").css("overflow", "");
        $(".line").removeClass("change");
      }

      $menuClose.off("click").on("click", closeMenu);
      $menuOverlay.off("click").on("click", closeMenu);

      const wrapper = document.querySelector(".mobile-menu-area .mobile-menu-wrapper");
      if (wrapper) {
        wrapper.addEventListener("click", function (e) {
          var link = e.target.closest(".menu-item-has-children > a");
          if (link) {
            e.preventDefault();
            e.stopPropagation();
            var submenu = link.nextElementSibling;
            if (submenu) {
              submenu.classList.toggle("open");
              link.closest(".menu-item-has-children").classList.toggle("submenu-open");
            }
            return;
          }
          var navLink = e.target.closest(".mobile-menu-nav > ul > li:not(.menu-item-has-children) > a, .mobile-menu-nav .sm-submenu a");
          if (navLink) {
            closeMenu();
          }
        });
      }

      // 8. Global Quote Modal toggle handlers
      $(".get-quote-btn").off("click").on("click", function (e) {
        e.preventDefault();
        $("#quoteModal").addClass("show");
        $("body").css("overflow", "hidden");
      });
      $(".quote-modal-close, .quote-done-btn").off("click").on("click", function () {
        $("#quoteModal").removeClass("show");
        $("body").css("overflow", "");
        $("#quoteSuccess").removeClass("show");
        $("#quoteForm").show();
      });
      $("#quoteForm").off("submit").on("submit", function (e) {
        e.preventDefault();
        // simulate success
        $(this).hide();
        $("#quoteSuccess").addClass("show");
      });

      // 9. FAQ accordion
      $(".faq-block-2 .accordion-list > li > .answer").hide();
      // keep first active open
      $(".faq-block-2 .accordion-list > li.active > .answer").show();
      $(".faq-block-2 .accordion-list > li").off("click").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active").find(".answer").slideUp();
        } else {
          $(".faq-block-2 .accordion-list > li.active .answer").slideUp();
          $(".faq-block-2 .accordion-list > li.active").removeClass("active");
          $(this).addClass("active").find(".answer").slideDown();
        }
        return false;
      });
    }
  }, []);

  return (
    <>

      <section className="page-hero" style={{ backgroundImage: "url('/assets/img/unsplash-1550751827-4bd374c3f58b.jpg')" }}>
        <div className="page-hero-overlay"></div>
        <div className="container">
          <div className="page-hero-content">
            <div className="hero-service-icon"><i className="fa fa-envelope"></i></div>
            <h1>Contact Us</h1>
            <nav className="breadcrumb-nav" aria-label="breadcrumb">
              <Link to="/">Home</Link><span className="sep">/</span>
              <span className="current">Contact Us</span>
            </nav>
          </div>
        </div>
      </section>
      <section id="contact" className="contact-1 pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="flip-left" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/87-trophy.svg')" }} data-aos="flip-right" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/20-circle-ring.svg')" }} data-aos="flip-up" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="flip-down" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/94-star-badge.svg')" }} data-aos="rotate-left" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/44-octagon.svg')" }} data-aos="rotate-right" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/48-octagon-outline.svg')" }} data-aos="fade-up" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/85-wave.svg')" }} data-aos="fade-down" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="fade-left" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">

          <div className="ebl-data-blocks">
            <div className="comingsoon-body-item block-item text-center" data-aos="flip-left" data-aos-delay="100">
              <div className="subtitle subtitle_1bececf">
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">Get In Touch</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item text-center" data-aos="flip-right" data-aos-delay="200">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>Contact Us For A Free Quote</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item text-center" data-aos="flip-left" data-aos-delay="300">
              <div className="plain_text plain_text_1bececf" style={{ maxWidth: "1000px", margin: "0 auto" }}>
                <p style={{ marginBottom: "40px" }}>
                  Ready to get started? Contact us today for a free consultation and quote on your IT requirements.
                </p>
                <div className="row text-center">
                  <div className="col-md-4 mb-4">
                    <div style={{ background: "#fff", padding: "30px 20px", borderRadius: "10px", boxShadow: "0 5px 15px rgba(0,0,0,0.05)", height: "100%", borderTop: "3px solid var(--color-primary)" }}>
                      <div style={{ fontSize: "32px", color: "var(--color-primary)", marginBottom: "15px" }}>
                        <i className="fa fa-file-invoice-dollar"></i>
                      </div>
                      <h4 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "10px", color: "#333" }}>Request a Quote</h4>
                      <p style={{ fontSize: "14px", color: "#666", marginBottom: 0 }}>Get a customized price estimate for your project needs</p>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div style={{ background: "#fff", padding: "30px 20px", borderRadius: "10px", boxShadow: "0 5px 15px rgba(0,0,0,0.05)", height: "100%", borderTop: "3px solid #ff4e00" }}>
                      <div style={{ fontSize: "32px", color: "#ff4e00", marginBottom: "15px" }}>
                        <i className="fa fa-calendar-check"></i>
                      </div>
                      <h4 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "10px", color: "#333" }}>Book a Consultation</h4>
                      <p style={{ fontSize: "14px", color: "#666", marginBottom: 0 }}>Schedule a meeting with our experts for the best solutions</p>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div style={{ background: "#fff", padding: "30px 20px", borderRadius: "10px", boxShadow: "0 5px 15px rgba(0,0,0,0.05)", height: "100%", borderTop: "3px solid #00b894" }}>
                      <div style={{ fontSize: "32px", color: "#00b894", marginBottom: "15px" }}>
                        <i className="fa fa-headset"></i>
                      </div>
                      <h4 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "10px", color: "#333" }}>Contact Information</h4>
                      <p style={{ fontSize: "14px", color: "#666", marginBottom: 0 }}>Reach out to us anytime for support and inquiries</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="comingsoon-body-item block-item">
              <div className="contact-wrap mt-3">
                <div className="row align-items-center">
                  <div className="col-lg-5" data-aos="flip-right" data-aos-delay="200">
                    <div className="contact-info mb-5 mb-lg-0">
                      <div className="contact-info-single">
                        <div className="icon">
                          <i className="fa fa-map-marker-alt"></i>
                        </div>
                        <div className="contact-text">
                          <div className="contact-heading">Location:</div>
                          <div>
                            Callsoftbd, Dhaka, Bangladesh
                          </div>
                        </div>
                      </div>
                      <div className="contact-info-single">
                        <div className="icon">
                          <i className="fa fa-envelope"></i>
                        </div>
                        <div className="contact-text">
                          <div className="contact-heading">Email:</div>
                          <div><a href="mailto:info@callsoftbd.com">info@callsoftbd.com</a></div>
                        </div>
                      </div>
                      <div className="contact-info-single">
                        <div className="icon">
                          <i className="fa fa-phone-alt"></i>
                        </div>
                        <div className="contact-text">
                          <div className="contact-heading">Phone:</div>
                          <div><a href="tel:+8801839602840">+880 1839-602840</a></div>
                        </div>
                      </div>
                      <div className="contact-info-single">
                        <div className="icon">
                          <i className="fa fa-clock"></i>
                        </div>
                        <div className="contact-text">
                          <div className="contact-heading">Working Hours:</div>
                          <div>
                            Saturday - Thursday: 8:00 AM - 6:00 PM
                          </div>
                        </div>
                      </div>
                      <div className="contact-info-single">
                        <div className="icon">
                          <i className="fa fa-globe"></i>
                        </div>
                        <div className="contact-text">
                          <div className="contact-heading">Website:</div>
                          <div><a href="https://www.callsoftbd.com" target="_blank" rel="noopener noreferrer">www.callsoftbd.com</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7" data-aos="flip-left" data-aos-delay="400">
                    <div className="contact-form-wrapper" style={{ background: "#fff", padding: "30px", borderRadius: "10px", boxShadow: "0 5px 20px rgba(0,0,0,0.05)" }}>
                      <QuoteForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ExperienceSection />

      {/* ============ GLOBAL SUPPORT MODEL SECTION ============ */}
      <section className="global-support-section pt-60 pb-60" style={{ backgroundColor: "#f8f9fb" }}>
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-down">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">Support Without Borders</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>Centralized Command, Global Delivery</span>
                <span></span>
              </h2>
            </div>
            <p className="lead-text mt-3" style={{ color: "#666", maxWidth: "700px", margin: "0 auto", fontSize: "1.05rem" }}>
              Our management and strategic operations are centralized in Ajman, Bangladesh and whole world, while our support engineers are strategically distributed across multiple countries to provide true follow-the-sun 24/7 support.
            </p>
          </div>

          <div className="row justify-content-center">
            {/* Card 1 */}
            <div className="col-lg-3 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
              <div className="ssc" style={{ height: "100%", background: "#fff", padding: "30px 20px", borderRadius: "8px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", textAlign: "center" }}>
                <div className="ssc-icon" style={{ background: "rgba(36, 0, 168, 0.05)", width: "60px", height: "60px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", color: "var(--color-primary)" }}>
                  <i className="fa fa-server" style={{ fontSize: "24px" }}></i>
                </div>
                <h3 style={{ fontSize: "1.2rem", fontWeight: "700", marginBottom: "12px", color: "#1a1a2e" }}>Centralized Operations</h3>
                <p style={{ fontSize: "0.9rem", color: "#555", lineHeight: "1.6" }}>
                  All management, quality audits, SLA guarantees, and architecture designs are centralized in Ajman, Bangladesh and whole worldto maintain premium standards.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-3 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="ssc" style={{ height: "100%", background: "#fff", padding: "30px 20px", borderRadius: "8px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", textAlign: "center" }}>
                <div className="ssc-icon" style={{ background: "rgba(36, 0, 168, 0.05)", width: "60px", height: "60px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", color: "var(--color-primary)" }}>
                  <i className="fa fa-globe" style={{ fontSize: "24px" }}></i>
                </div>
                <h3 style={{ fontSize: "1.2rem", fontWeight: "700", marginBottom: "12px", color: "#1a1a2e" }}>Multi-Country Support</h3>
                <p style={{ fontSize: "0.9rem", color: "#555", lineHeight: "1.6" }}>
                  We coordinate with specialized technical teams and helpdesks based in different countries to deliver native local-time responses.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-3 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
              <div className="ssc" style={{ height: "100%", background: "#fff", padding: "30px 20px", borderRadius: "8px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", textAlign: "center" }}>
                <div className="ssc-icon" style={{ background: "rgba(36, 0, 168, 0.05)", width: "60px", height: "60px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", color: "var(--color-primary)" }}>
                  <i className="fa fa-headset" style={{ fontSize: "24px" }}></i>
                </div>
                <h3 style={{ fontSize: "1.2rem", fontWeight: "700", marginBottom: "12px", color: "#1a1a2e" }}>Follow-The-Sun SLA</h3>
                <p style={{ fontSize: "0.9rem", color: "#555", lineHeight: "1.6" }}>
                  By handoff ticketing across different country teams, we guarantee 24/7 technical monitoring and rapid crisis response without gaps.
                </p>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-lg-3 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="400">
              <div className="ssc" style={{ height: "100%", background: "#fff", padding: "30px 20px", borderRadius: "8px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", textAlign: "center" }}>
                <div className="ssc-icon" style={{ background: "rgba(36, 0, 168, 0.05)", width: "60px", height: "60px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", color: "var(--color-primary)" }}>
                  <i className="fa fa-shield-alt" style={{ fontSize: "24px" }}></i>
                </div>
                <h3 style={{ fontSize: "1.2rem", fontWeight: "700", marginBottom: "12px", color: "#1a1a2e" }}>Fail-Safe Redundancy</h3>
                <p style={{ fontSize: "0.9rem", color: "#555", lineHeight: "1.6" }}>
                  Geo-distribution ensures that a localized network outage or disaster never impacts our capability to keep your servers protected.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ CLIENT COMMITMENTS SECTION ============ */}
      <section className="client-commitments-section pt-60 pb-60" style={{ backgroundColor: "#ffffff" }}>
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-down">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">Pillars of Trust</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>Our Core Commitments to Clients</span>
                <span></span>
              </h2>
            </div>
            <p className="lead-text mt-3" style={{ color: "#666", maxWidth: "700px", margin: "0 auto", fontSize: "1.05rem" }}>
              We don't just provide services—we commit to standards of excellence, safety, and reliability designed to build lasting business partnerships.
            </p>
          </div>

          <div className="row justify-content-center">
            {/* Commitment 1 */}
            <div className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
              <div className="commitment-card" style={{ height: "100%", background: "#f8f9fb", padding: "40px 30px", borderRadius: "10px", border: "1px solid #eaeaea", transition: "transform 0.3s ease" }}>
                <div className="icon-wrap mb-3" style={{ color: "var(--color-secondary)", fontSize: "36px" }}>
                  <i className="fa fa-tachometer-alt"></i>
                </div>
                <h3 style={{ fontSize: "1.25rem", fontWeight: "700", marginBottom: "15px", color: "#1a1a2e" }}>15-Min Critical SLA</h3>
                <p style={{ fontSize: "0.95rem", color: "#555", lineHeight: "1.6" }}>
                  We commit to responding and acting within 15 minutes of any high-severity incident or server-down emergency. Our distributed helpdesk is permanently on alert to keep your business online.
                </p>
              </div>
            </div>

            {/* Commitment 2 */}
            <div className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="commitment-card" style={{ height: "100%", background: "#f8f9fb", padding: "40px 30px", borderRadius: "10px", border: "1px solid #eaeaea", transition: "transform 0.3s ease" }}>
                <div className="icon-wrap mb-3" style={{ color: "var(--color-secondary)", fontSize: "36px" }}>
                  <i className="fa fa-file-invoice-dollar"></i>
                </div>
                <h3 style={{ fontSize: "1.25rem", fontWeight: "700", marginBottom: "15px", color: "#1a1a2e" }}>Zero Hidden Costs</h3>
                <p style={{ fontSize: "0.95rem", color: "#555", lineHeight: "1.6" }}>
                  Complete transparency. We guarantee simple monthly invoicing, clear breakdown of engineering hours, and upfront flat-rate options. No setups fees, termination penalties, or surprise invoices.
                </p>
              </div>
            </div>

            {/* Commitment 3 */}
            <div className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
              <div className="commitment-card" style={{ height: "100%", background: "#f8f9fb", padding: "40px 30px", borderRadius: "10px", border: "1px solid #eaeaea", transition: "transform 0.3s ease" }}>
                <div className="icon-wrap mb-3" style={{ color: "var(--color-secondary)", fontSize: "36px" }}>
                  <i className="fa fa-user-shield"></i>
                </div>
                <h3 style={{ fontSize: "1.25rem", fontWeight: "700", marginBottom: "15px", color: "#1a1a2e" }}>Senior L3 Engineers Only</h3>
                <p style={{ fontSize: "0.95rem", color: "#555", lineHeight: "1.6" }}>
                  Your production servers and architectures are too valuable for juniors. We commit that only certified senior systems engineers and cloud architects will manage and interact with your platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  );
}
